import { Col } from 'antd'
import Checkbox from 'components/Form/Checkbox'
import { FormItem } from 'components/Select'
import React, { useContext } from 'react'
import ArrowDownIcon from '../../../../../../components/icons/ArrowDownIco'
import {
  checkFormatNumber,
  formatNumber,
} from '../../../RuleEngineCommonFunction'
import { RuleContext } from '../../RulesCreationTable'
import {
  StyledInputNumber,
  StyledRuleRow,
  StyledSymbolWithIcon,
  StyledTextInput,
} from '../../style'
import {
  CheckboxTextContent,
  StyledBoldTextOne,
  StyledBoldTextTwo,
  TextContainer,
  TextLine,
} from './style'
const CTCDrawer = () => {
  const {
    ruleForm,
    setState,
    state: { ctcRule },
  } = useContext(RuleContext)
  const handleChange = (value, fieldName) => {
    const currentCTCThreshold = ruleForm.getFieldValue('ctcRule')
    ruleForm.setFieldsValue({
      ctcRule: {
        ...currentCTCThreshold,
        [fieldName]: value,
        // isEnabled: true,
      },
    })
    setState(prevState => ({
      ...prevState,
      ctcRule: {
        ...currentCTCThreshold,
        [fieldName]: value,
        // isEnabled: true,
      },
    }))
  }

  return (
    <>
      {' '}
      <TextContainer>
        <TextLine>
          This CTC threshold is specifically applicable to PIL corporates who
          are posting the job role.
        </TextLine>
        <TextLine>
          All roles floated by PIL corporates adhere to this CTC requirement.
        </TextLine>
      </TextContainer>
      <StyledRuleRow pBottom={20} pTop={30} align={'middle'}>
        <Col md={10}>
          <StyledBoldTextOne>Minimum Threshold</StyledBoldTextOne>
        </Col>
        <Col>
          <FormItem
            name={['ctcRule', 'compensation']}
            rules={[
              () => ({
                validator(_, value) {
                  if (value == 0 || !value) {
                    return Promise.reject(
                      new Error('Please enter the minimum threshold')
                    )
                  }
                  return Promise.resolve()
                },
              }),
            ]}
          >
            <StyledInputNumber
              width="200px"
              height={'40px'}
              style={{
                height: '40px',
                width: '200px',
                background: '#FFFFFF',
                border: '1px solid #D6DBF7',
                boxShadow: ' 0px 2px 6px 0px #7b61ff26',
              }}
              formatter={value => formatNumber(value)}
              parser={value => checkFormatNumber(value)}
              prefix={
                <StyledSymbolWithIcon prefixWithIcon>
                  ₹ <ArrowDownIcon style={{ marginLeft: '4px' }} />
                </StyledSymbolWithIcon>
              }
              value={ctcRule?.compensation || ''}
              onChange={value => handleChange(value, 'compensation')}
              placeholder="0,00,000"
            />
          </FormItem>
        </Col>
      </StyledRuleRow>
      <StyledRuleRow align={'middle'}>
        <Col md={10}>
          <CheckboxTextContent>
            <FormItem
              name={['ctcRule', 'allowClosestCTC']}
              rules={[
                {
                  required: false,
                  message: 'Please enter the CTC Type',
                },
              ]}
              customWidth={'fit-content'}
            >
              <Checkbox
                checked={ctcRule?.allowClosestCTC}
                onChange={e =>
                  handleChange(e.target.checked, 'allowClosestCTC')
                }
                value={ctcRule?.allowClosestCTC}
                label={
                  <StyledBoldTextTwo>Allow closest CTC up to</StyledBoldTextTwo>
                }
              ></Checkbox>
            </FormItem>
          </CheckboxTextContent>
        </Col>
        <Col>
          <FormItem
            name={['ctcRule', 'closestCtcRate']}
            rules={[
              // {
              //   required: ctcRule?.allowClosestCTC, // Check the flag
              //   message: 'Please enter the Allow closest CTC',
              // },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (value == 0 && ctcRule?.allowClosestCTC) {
                    return Promise.reject(
                      new Error('Please enter the Allow closest CTC')
                    )
                  }

                  if (value < 0) {
                    return Promise.reject(new Error('negative values are not allowed'))
                  }

                  if (value > 100) {
                    return Promise.reject(new Error('Not Valid!'))
                  }

                  return Promise.resolve()
                },
              }),
            ]}
          >
            <StyledTextInput
              type="number"
              width="90px"
              height={'40px'}
              onChange={e => handleChange(e.target.value, 'closestCtcRate')}
              value={ctcRule?.closestCtcRate}
              disabled={!ctcRule?.allowClosestCTC}
              prefix="-"
              suffix="%"
              placeholder={'0'}
            />
          </FormItem>
        </Col>
      </StyledRuleRow>
    </>
  )
}

export default CTCDrawer
